// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"741":"28546530","1517":"f846dbaa","3897":"3fdbe4f7","5477":"78a0fc47","6212":"cdc73446","9698":"c0961b28"}[chunkId] + ".chunk.css";
};